import Logo from "../Logo/LogoMedium.png"

const LogoComponent = () => (
    <>
        <img src={Logo} alt='website logo' className="mx-2"/>
    </>
);

export default LogoComponent;